import React from "react"
import { useSelector } from "react-redux"
import { getMyProffesionalData } from "../../store/session/selectors"
import ClientPacksTable from "../Clients/ClientPacksTable"
import { ClientEntity } from "../../store/entities/state"
import TitledContainer from "../../components/TitledContainer"
import { useTranslations } from "../../store/translations/hooks"
import { TK } from "../../store/translations/translationKeys"

export const MyPacksPage = () => {
  const t = useTranslations()
  const myProfessional = useSelector(getMyProffesionalData)
  return (
    <TitledContainer id={'my-packs-page'} title={t(TK.myPacks)}>
      <ClientPacksTable isOpen client={myProfessional as ClientEntity} clientIsProfessional />
    </TitledContainer>
  )
}
